import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import DashboardIcon from "@material-ui/icons/Dashboard";
import ChatIcon from "@material-ui/icons/Chat";
import TrendingUpIcon from "@material-ui/icons/TrendingUp";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(6, 0, 2),
  },
  label: {
    textAlign: "center",
    color: "#58EFFE",
    fontSize: "0.76rem",
    fontWeight: 700,
    letterSpacing: "0.15em",
    textTransform: "uppercase",
    marginBottom: theme.spacing(1.2),
  },
  title: {
    textAlign: "center",
    color: "#ffffff",
    fontSize: "clamp(1.6rem, 3.5vw, 2.4rem)",
    fontWeight: 800,
    letterSpacing: "-0.02em",
    margin: 0,
    marginBottom: theme.spacing(5),
  },
  mockup: {
    position: "relative",
    maxWidth: 920,
    margin: "0 auto",
    borderRadius: 20,
    border: "1px solid rgba(255, 255, 255, 0.06)",
    background: "rgba(255, 255, 255, 0.02)",
    backdropFilter: "blur(12px)",
    overflow: "hidden",
    padding: theme.spacing(2.5),
    boxShadow: "0 24px 60px rgba(0, 0, 0, 0.4), 0 0 80px rgba(88, 239, 254, 0.04)",
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(1.5),
      borderRadius: 14,
    },
  },
  toolbar: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    marginBottom: theme.spacing(2),
    paddingBottom: theme.spacing(1.5),
    borderBottom: "1px solid rgba(255, 255, 255, 0.05)",
  },
  toolbarDot: {
    width: 10,
    height: 10,
    borderRadius: "50%",
  },
  toolbarUrl: {
    flex: 1,
    marginLeft: 12,
    padding: "5px 14px",
    borderRadius: 8,
    background: "rgba(255, 255, 255, 0.04)",
    color: "rgba(255, 255, 255, 0.25)",
    fontSize: "0.72rem",
    border: "1px solid rgba(255, 255, 255, 0.04)",
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: theme.spacing(1.5),
    [theme.breakpoints.down("sm")]: {
      gridTemplateColumns: "1fr",
    },
  },
  card: {
    padding: theme.spacing(2),
    borderRadius: 14,
    border: "1px solid rgba(255, 255, 255, 0.05)",
    background: "rgba(255, 255, 255, 0.02)",
    transition: "border-color 0.3s ease",
    "&:hover": {
      borderColor: "rgba(88, 239, 254, 0.15)",
    },
  },
  cardIcon: {
    width: 38,
    height: 38,
    borderRadius: 10,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: theme.spacing(1),
    background: "linear-gradient(135deg, rgba(88, 239, 254, 0.1), rgba(57, 243, 204, 0.05))",
    color: "#58EFFE",
  },
  cardLabel: {
    color: "rgba(255, 255, 255, 0.35)",
    fontSize: "0.7rem",
    fontWeight: 600,
    letterSpacing: "0.06em",
    textTransform: "uppercase",
    marginBottom: 4,
  },
  cardValue: {
    color: "#ffffff",
    fontSize: "1.5rem",
    fontWeight: 800,
    lineHeight: 1,
  },
  cardTrend: {
    display: "inline-flex",
    alignItems: "center",
    gap: 3,
    marginTop: 8,
    padding: "3px 10px",
    borderRadius: 6,
    fontSize: "0.7rem",
    fontWeight: 700,
    background: "rgba(57, 243, 204, 0.08)",
    color: "#39F3CC",
    border: "1px solid rgba(57, 243, 204, 0.12)",
  },
  chatMock: {
    marginTop: theme.spacing(1.5),
    padding: theme.spacing(1.5),
    borderRadius: 14,
    border: "1px solid rgba(255, 255, 255, 0.05)",
    background: "rgba(255, 255, 255, 0.02)",
    gridColumn: "1 / -1",
    display: "flex",
    gap: theme.spacing(1),
    alignItems: "flex-start",
    [theme.breakpoints.down("sm")]: { gridColumn: "auto" },
  },
  chatBubble: {
    maxWidth: "70%",
    padding: theme.spacing(1, 1.5),
    borderRadius: 12,
    fontSize: "0.78rem",
    lineHeight: 1.45,
  },
  chatUser: {
    background: "rgba(88, 239, 254, 0.08)",
    color: "rgba(255, 255, 255, 0.7)",
    borderBottomLeftRadius: 4,
    marginRight: "auto",
    border: "1px solid rgba(88, 239, 254, 0.08)",
  },
  chatBot: {
    background: "rgba(57, 243, 204, 0.06)",
    color: "rgba(255, 255, 255, 0.7)",
    borderBottomRightRadius: 4,
    marginLeft: "auto",
    border: "1px solid rgba(57, 243, 204, 0.08)",
  },
  glow: {
    position: "absolute",
    width: 350,
    height: 350,
    bottom: -100,
    right: -100,
    borderRadius: "50%",
    pointerEvents: "none",
    filter: "blur(80px)",
    background: "radial-gradient(circle, rgba(88, 239, 254, 0.1), transparent 70%)",
  },
}));

export default function PreviewSection({ resolveText }) {
  const classes = useStyles();

  return (
    <section className={`${classes.root} gsap-fade-in`}>
      <p className={classes.label}>
        {resolveText("landing.preview.label") !== "landing.preview.label"
          ? resolveText("landing.preview.label")
          : "Asi se ve por dentro"}
      </p>
      <h2 className={classes.title}>
        {resolveText("landing.preview.title") !== "landing.preview.title"
          ? resolveText("landing.preview.title")
          : "Todo tu negocio en un solo lugar"}
      </h2>

      <div className={classes.mockup}>
        <div className={classes.glow} />

        <div className={classes.toolbar}>
          <span className={classes.toolbarDot} style={{ background: "#ff5f57" }} />
          <span className={classes.toolbarDot} style={{ background: "#febc2e" }} />
          <span className={classes.toolbarDot} style={{ background: "#28c840" }} />
          <span className={classes.toolbarUrl}>klorum.com/dashboard</span>
        </div>

        <div className={classes.grid}>
          <div className={classes.card}>
            <div className={classes.cardIcon}><DashboardIcon fontSize="small" /></div>
            <div className={classes.cardLabel}>Leads activos</div>
            <div className={classes.cardValue}>2,847</div>
            <div className={classes.cardTrend}><TrendingUpIcon style={{ fontSize: 12 }} /> +18%</div>
          </div>

          <div className={classes.card}>
            <div className={classes.cardIcon}><ChatIcon fontSize="small" /></div>
            <div className={classes.cardLabel}>Conversaciones</div>
            <div className={classes.cardValue}>12,403</div>
            <div className={classes.cardTrend}><TrendingUpIcon style={{ fontSize: 12 }} /> +32%</div>
          </div>

          <div className={classes.card}>
            <div className={classes.cardIcon}><TrendingUpIcon fontSize="small" /></div>
            <div className={classes.cardLabel}>Conversion</div>
            <div className={classes.cardValue}>24.6%</div>
            <div className={classes.cardTrend}><TrendingUpIcon style={{ fontSize: 12 }} /> +5.2%</div>
          </div>

          <div className={classes.chatMock}>
            <div style={{ flex: 1, display: "flex", flexDirection: "column", gap: 8 }}>
              <div className={`${classes.chatBubble} ${classes.chatUser}`}>
                Hola, me interesa el plan Pro
              </div>
              <div className={`${classes.chatBubble} ${classes.chatBot}`}>
                Excelente! Te cuento los beneficios del plan Pro y te ayudo a activarlo ahora mismo
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
